import PropTypes from 'prop-types';
import React from 'react';
import { asyncConnect } from 'redux-connect';
import { Link } from 'react-router-dom';
// import { flashHighlight, get, toPlural } from 'helpers/HelperFunctions';
import { get, getBrowseURL } from 'helpers/HelperFunctions';
import moment from 'moment';

import Button from 'react-bootstrap/lib/Button';

import Breadcrumbs from 'components/Shared/Breadcrumbs';
import BriefDetail from 'components/BriefDetailsClient/BriefDetail/BriefDetail';
import BriefDetailsFreelancer from 'containers/BriefDetailsFreelancer/BriefDetailsFreelancer';
import BuyerOnboarding from 'components/BriefDetailsClient/BuyerOnboarding/BuyerOnboarding';
import Label from 'components/Label/Label';
import Loader from 'components/Loader/Loader';
import Modal from 'components/Modal/Modal';
import NotFound from 'containers/NotFound/NotFound';
import PublicQuestionsList from 'components/BriefDetailsClient/PublicQuestionsList/PublicQuestionsList';
import SvgIcon from 'components/SvgIcon/SvgIcon';
import UserSnippets from 'components/Shared/UserSnippets/UserSnippets';
import Expandable from 'components/Shared/Expandable/Expandable';
import PendingPitchCounter from 'components/BriefDetailsClient/PendingPitchCounter/PendingPitchCounter';
import { trackEvent } from 'helpers/Analytics';

import {
  update as updateUser,
  updateLocal as updateLocalUser,
} from 'redux/modules/auth';

import {
  setSelectedRoleCategory,
  clearSelectedRoleCategory,
} from 'redux/modules/selectedRoleCategory';

import {
  acceptPitch,
  addVoucher,
  declinePitch,
  decrementTotalPendingQuestions,
  invite,
  loadBrief,
  loadInvites,
  // loadSuggestedCreatives,
  loadPendingPublicQuestions,
  loadPublicQuestions,
  removeSuggestedCreative,
  updateBrief,
} from 'redux/modules/briefs2';

import { setPortfolioCarousel } from 'redux/modules/landingPages';

import { answerQuestion as answerPublicQuestion } from 'redux/modules/publicQuestions2';

import { setSuccessMessage } from 'redux/modules/successMessage';

import { sendMessage, markAsRead } from 'redux/modules/messages';

// TODO: Remove after BriefDetails (v1) is done with
import {
  isBriefLoaded as isBriefLoadedOld,
  loadBrief as loadBriefOld,
} from 'redux/modules/briefDetails';

import { getActiveAndCompletedHires } from 'redux/modules/briefCard';
import PitchBox from 'components/BriefDetailsClient/PitchBox/PitchBox';
import styles from './BriefDetailsClient.module.scss';
import { getRoleCategory } from 'helpers/Constants';

@asyncConnect(
  [
    {
      promise: ({
        store: { dispatch, getState },
        match: {
          params: { id },
        },
      }) => {
        const promises = [];

        const encodedId = id ? id.split('-')[0] : null;

        if (encodedId && !get(getState(), ['briefs2', encodedId])) {
          promises.push(dispatch(loadBrief(encodedId)));
        }

        // TODO: Remove after BriefDetails (v1) is done with
        if (!isBriefLoadedOld(getState())) {
          promises.push(dispatch(loadBriefOld(encodedId || id)));
        }

        return Promise.all(promises);
      },
    },
  ],
  (state) => ({
    auth: state.auth,
    briefs: state.briefs2,
    invitedFreelancers: state.briefs.invitedFreelancers,
    entities: state.entities,
    publicQuestions: state.publicQuestions2,
    activeHires: state.briefCard.activeHires,
  }),
  {
    acceptPitch,
    addVoucher,
    answerPublicQuestion,
    declinePitch,
    decrementTotalPendingQuestions,
    invite,
    loadBrief,
    loadInvites,
    // loadSuggestedCreatives,
    loadPendingPublicQuestions,
    loadPublicQuestions,
    removeSuggestedCreative,
    sendMessage,
    setPortfolioCarousel,
    setSuccessMessage,
    updateBrief,
    updateUser,
    updateLocalUser,
    getActiveAndCompletedHires,
    markAsRead,
    setSelectedRoleCategory,
    clearSelectedRoleCategory,
  }
)
class BriefDetailsClient extends React.Component {
  static propTypes = {
    auth: PropTypes.object,
    briefs: PropTypes.object,
    entities: PropTypes.object,
    invitedFreelancers: PropTypes.array,
    location: PropTypes.object,
    params: PropTypes.object,
    publicQuestions: PropTypes.object,
    //
    acceptPitch: PropTypes.func,
    addVoucher: PropTypes.func,
    answerPublicQuestion: PropTypes.func,
    declinePitch: PropTypes.func,
    decrementTotalPendingQuestions: PropTypes.func,
    invite: PropTypes.func,
    loadBrief: PropTypes.func,
    loadInvites: PropTypes.func,
    // loadSuggestedCreatives: React.PropTypes.func,
    loadPendingPublicQuestions: PropTypes.func,
    loadPublicQuestions: PropTypes.func,
    removeSuggestedCreative: PropTypes.func,
    sendMessage: PropTypes.func,
    setPortfolioCarousel: PropTypes.func,
    setSuccessMessage: PropTypes.func,
    updateBrief: PropTypes.func,
    updateUser: PropTypes.func,
    updateLocalUser: PropTypes.func,
    activeHires: PropTypes.array,
    getActiveAndCompletedHires: PropTypes.func,
    markAsRead: PropTypes.func,
    match: PropTypes.object,
    history: PropTypes.object,
    setSelectedRoleCategory: PropTypes.func,
    clearSelectedRoleCategory: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      showAddVoucher: false,
      showCompanyCheck: !!props.location.query.onboarding,
      voucherCode: '',
      invitedFreelancers: get(
        this.getBrief(props),
        ['invites', 'invites'],
        []
      ).map((inviteEntityId) =>
        get(props.entities, [
          'users',
          get(props.entities, ['invites', inviteEntityId, 'user_id']),
        ])
      ),
    };

    // this.initLoadSuggested = this.initLoadSuggested.bind(this);
  }

  componentDidMount() {
    const {
      auth,
      briefs,
      getActiveAndCompletedHires,
      match: { params },
      location,
      loadBrief,
      setSelectedRoleCategory,
      history,
    } = this.props;

    const brief = this.getBrief();

    // Track old URL visits and redirect owner clients to new ATS URL
    // Only run when brief becomes available (wasn't available before, is now)
    if (brief && auth.user && brief.user_id === auth.user.id) {
      // Check if this is the old /projects/{hash} URL (not /projects/{hash}/ats or other subsections)
      if (!params.subsection) {
        const referrer = document.referrer || 'direct';
        const currentPath = window.location.pathname;
        // Track the old URL visit
        trackEvent('old_ats_url_visited', {
          oldUrl: currentPath,
          referrer: referrer,
          briefId: this.getEncodedId(),
          userType: auth.user.type,
        });

        // Redirect to new ATS URL
        const newUrl = brief.links.ats_main_relative || `/ats/${params.id}`;
        history.replace(newUrl);
      }
    }

    if (params.subsection === 'review' && brief && auth.user) {
      trackEvent('user-lands-on-post-review', {
        role: brief.role,
        skill: brief.skill,
        loggedIn: !!auth.user,
        userType: auth.user ? auth.user.type : 'guest',
      });
    } else if (brief && auth.user && brief.user_id === auth.user.id) {
      // only fires when client is on their own brief
      trackEvent('user-landed-on-job-status-details-page', {
        role: brief.role,
        skill: brief.skill,
        loggedIn: !!auth.user,
        userType: auth.user ? auth.user.type : 'guest',
      });
    }

    if (!auth.user && location.query.utm_source === 'email') {
      const encodedId = this.getEncodedId();
      document.location = `/signin?referer=${encodeURIComponent(
        `/projects/${encodedId}`
      )}`;
    }

    // Close job if have permissions and "close_job" set
    if (
      brief &&
      auth.user &&
      brief.user_id === auth.user.id &&
      location.query.close_job
    ) {
      this.handleCloseJobForNewPitches();
      this.props.setSuccessMessage('Job closed to new applicants');
    }

    // Decline pitch if have permissions and "decline_pitch" set
    if (
      brief &&
      auth.user &&
      brief.user_id === auth.user.id &&
      location.query.decline_pitch
    ) {
      // Decline the pitch
      const encodedId = this.getEncodedId();
      this.props.declinePitch(encodedId, brief, {
        id: location.query.decline_pitch,
      });

      // Rebuild the query string without the decline_pitch parameter
      const query = { ...location.query };
      delete query.decline_pitch;
      const newSearch = Object.keys(query)
        .map((key) => `${key}=${encodeURIComponent(query[key])}`)
        .join('&');

      // Reload page without the decline_pitch parameter
      window.location.href = `${location.pathname}${
        newSearch ? '?' + newSearch : ''
      }${location.hash}`;
    }

    // Do the confirmation message of declining pitch after redirect
    if (
      brief &&
      auth.user &&
      brief.user_id === auth.user.id &&
      !location.query.decline_pitch &&
      window.location.href.includes('=not_interested')
    ) {
      this.props.setSuccessMessage('Marked applicant as not interested');
    }

    const encodedId = this.getEncodedId();
    if (
      brief &&
      !get(briefs, [encodedId, 'loading'], false) &&
      !get(briefs, [encodedId, 'loaded'], false)
    ) {
      loadBrief(encodedId);
    }

    if (brief && brief.role) {
      setSelectedRoleCategory(getRoleCategory(brief.role));
    }

    // this.initLoadSuggested();
    this.initLoadPublicQuestions(true);
    this.initLoadPublicQuestions(false);

    if (!this.state.activeHires) {
      const encodedId = this.getEncodedId();
      getActiveAndCompletedHires(encodedId).then((result) => {
        this.setState({ activeHires: result });
      });
    }
  }

  UNSAFE_componentWillUpdate(nextProps) {
    const { briefs } = this.props;

    // Get the encoded ID for use throughout the method
    const encodedId = this.getEncodedId();

    if (
      !get(briefs, [encodedId, 'acceptedPitch'], null) &&
      get(nextProps.briefs, [encodedId, 'acceptedPitch'], null)
    ) {
      location.reload();
    }
  }

  componentDidUpdate(prevProps) {
    // const { brief, params } = this.props;

    // this.initLoadSuggested();
    this.initLoadPublicQuestions(true);
    this.initLoadPublicQuestions(false);

    /* if (!! this.getBrief()
      && get(briefs, [params.id, 'suggested'], []).length !== get(prevProps.briefs, [params.id, 'suggested'], []).length
      && get(briefs, [params.id, 'suggested'], []).length < 8
      && ! get(briefs, [params.id, 'loadingSuggested'], false)
      && get(briefs, [params.id, 'moreSuggested'], false)) {
      this.props.loadSuggestedCreatives(params.id, this.getBrief());
    }*/

    // adding voucher
    if (
      !!this.getBrief() &&
      this.getBrief().voucher_id > 0 &&
      this.getBrief(prevProps) &&
      this.getBrief().voucher_id !== this.getBrief(prevProps).voucher_id
    ) {
      this.props.setSuccessMessage('Voucher added');
    }
  }

  componentWillUnmount() {
    this.props.clearSelectedRoleCategory();
  }

  getEncodedId = (props = this.props) => {
    const { match } = props;
    const urlId = match?.params?.id;
    return urlId ? urlId.split('-')[0] : null;
  };

  getBrief = (props = this.props) => {
    const encodedId = this.getEncodedId(props);
    return get(
      props.entities,
      ['briefs', get(props.briefs, [encodedId, 'id'])],
      null
    );
  };

  handleAcceptPitch(pitch, totalToPay) {
    const brief = this.getBrief();
    this.props.history.push(
      `/manage/briefs/${brief.id}/pay/${pitch.id}?amount=${totalToPay}&isHire=true`
    );
  }

  handleAnswerQuestion(brief, question, answer) {
    this.props.answerPublicQuestion(brief, question, answer);
    const encodedId = this.getEncodedId();
    this.props.decrementTotalPendingQuestions(encodedId);
  }

  handleUpdateBrief(brief, fields, tempAvatar, key = '') {
    if (fields.brief) {
      const encodedId = this.getEncodedId();
      this.props.updateBrief(encodedId, brief, fields.brief);
    }

    if (typeof fields.user !== 'undefined') {
      this.handleUpdateUser(fields.user, tempAvatar, key);
    }
  }

  handleCloseJobForNewPitches = () => {
    // Set `expires_at` to NOW()
    const newExpiryDate = moment(moment.utc()).format('YYYY-MM-DD HH:mm:ss');
    this.updateBriefExpiresAt(newExpiryDate);
  };

  handleOpenJobForNewPitches = () => {
    // Set `expires_at` to NOW() + 1 month
    const newExpiryDate = moment(moment.utc())
      .add(1, 'month')
      .format('YYYY-MM-DD HH:mm:ss');
    this.updateBriefExpiresAt(newExpiryDate);
  };

  handleEnableAIRecruiter = () => {
    const { updateBrief, loadBrief, briefs } = this.props;
    const brief = this.getBrief();
    const encodedId = this.getEncodedId();

    if (typeof brief !== 'undefined') {
      updateBrief(encodedId, brief, { ai_recruiter: true }).then(() => {
        if (!get(briefs, [encodedId, 'loading'], false)) {
          loadBrief(encodedId);
        }
      });
    }
  };

  handleDisableAIRecruiter = () => {
    const { updateBrief, loadBrief, briefs } = this.props;
    const brief = this.getBrief();
    const encodedId = this.getEncodedId();

    if (typeof brief !== 'undefined') {
      updateBrief(encodedId, brief, { ai_recruiter: false }).then(() => {
        if (!get(briefs, [encodedId, 'loading'], false)) {
          loadBrief(encodedId);
        }
      });
    }
  };

  handleUpdateOrganisation(organisation) {
    this.handleUpdateUser({ organisation }, 'organisation');
    this.setState({ showCompanyCheck: false });

    const { query } = this.props.location;
    delete query.onboarding;

    this.props.history.replace(
      `${this.props.location.pathname}?${Object.keys(query)
        .map((key) => `${key}=${query[key]}`)
        .join('&')}`
    );
  }

  handleUpdateUser(fields, tempAvatar, key) {
    this.props.updateUser(this.props.auth.user, fields, false, [], key);

    if (tempAvatar) {
      this.props.updateLocalUser(this.props.auth.user.id, {
        avatars: { temp: tempAvatar },
      });
    }
  }

  handleBrowseFreelancers = () => {
    const brief = this.getBrief();

    // Pick first that is defined (between :role and :skill)
    if (brief) {
      const { role, skill, location } = brief;

      return getBrowseURL({ role, skill, location });
    }
  };

  // Updates brief's `expires_at` and reloads it afterwards
  updateBriefExpiresAt = (expiryDate) => {
    const { updateBrief, loadBrief, briefs } = this.props;
    const brief = this.getBrief();

    const encodedId = this.getEncodedId();

    if (typeof brief !== 'undefined') {
      updateBrief(encodedId, brief, { expires_at: expiryDate }).then(() => {
        if (!get(briefs, [encodedId, 'loading'], false)) {
          loadBrief(encodedId);
        }
      });
    }
  };

  initLoadInvites() {
    const { auth, briefs } = this.props;

    const encodedId = this.getEncodedId();

    // Only load if we don't already have the invites,
    // the brief is active and belongs to current logged in user
    if (
      this.getBrief() &&
      this.getBrief().user === get(auth, ['user', 'id'], null) &&
      !get(briefs, [encodedId, 'loadedInvites'], false) &&
      !get(briefs, [encodedId, 'loadingInvites'], false)
    ) {
      this.props.loadInvites(encodedId, this.getBrief());
    }
  }

  /* initLoadSuggested() {
    const { auth, briefs, params } = this.props;

    // Only load if we don't already have the suggested creatives,
    // the brief is active and belongs to current logged in user
    if (this.getBrief()
      && (this.getBrief().status === 'pending_approval' || this.getBrief().status === 'active')
      && this.getBrief().user === get(auth, ['user', 'id'], null)
      && ! get(briefs, [params.id, 'loadedSuggested'], false)
      && ! get(briefs, [params.id, 'loadingSuggested'], false)) {
      this.props.loadSuggestedCreatives(params.id, this.getBrief());
    }
  } */

  initLoadPublicQuestions = (pending = true) => {
    const { briefs } = this.props;

    const encodedId = this.getEncodedId();

    if (
      this.getBrief() &&
      !get(briefs, [encodedId, 'loadedPublicQuestions'], false) &&
      !get(briefs, [encodedId, 'loadingPublicQuestions'], false)
    ) {
      if (pending) {
        this.props.loadPendingPublicQuestions(encodedId);
      } else {
        this.props.loadPublicQuestions(encodedId);
      }
    }
  };

  render() {
    const {
      auth,
      briefs,
      entities,
      match: { params },
      publicQuestions,
    } = this.props;

    const encodedId = this.getEncodedId();
    const {
      invitedFreelancers,
      showAddVoucher,
      showCompanyCheck,
      voucherCode,
    } = this.state;

    const hasInvited = invitedFreelancers.length > 0;

    const brief = this.getBrief();
    const owner =
      brief && auth.user && brief.user_id === auth.user.id
        ? get(auth, ['user'], null)
        : brief
        ? get(entities, ['users', brief.user_id], null)
        : null;

    const totalPendingPublicQuestions = get(
      briefs,
      [encodedId, 'totalPendingPublicQuestions'],
      0
    );

    // if loading
    if (get(briefs, [encodedId, 'loading'], false)) {
      return <Loader className={styles.loader} loading />;
    }

    // if loaded but not found
    if (get(briefs, [encodedId, 'loaded'], false) && !brief) {
      return <NotFound />;
    }

    // if loaded but deleted - only show this if we're sure it's deleted and not still loading
    // Check if brief is fully loaded and not in a loading state before determining it's deleted
    const briefIsLoading = get(briefs, [encodedId, 'loading'], false);
    const briefIsFullyLoaded = get(briefs, [encodedId, 'loaded'], false);

    if (
      briefIsFullyLoaded &&
      !briefIsLoading &&
      brief &&
      brief.deleted_at !== ''
    ) {
      return (
        <div className={`container ${styles.container}`}>
          {header}
          <Breadcrumbs className={styles.breadcrumbs}>
            <Link to="/ats">Manage Jobs</Link>
            Job Status
          </Breadcrumbs>

          <div className={styles.deletedBrief}>This job has been deleted</div>
        </div>
      );
    }

    const header = (
      <h1 className={styles.header}>
        <span className={styles.headerIcon}>
          <Link to={'/ats'}>
            <SvgIcon icon="chevron-left" size="24" />
          </Link>
        </span>
        {get(brief, ['text'])}
      </h1>
    );

    if (params.subsection === 'review' && brief) {
      if (!auth.user || !brief || auth.user.id !== brief.user_id) {
        return this.props.history.replace('/');
      }

      return (
        <div className={`container ${styles.container}`}>
          <h3 className={styles.header}>
            <SvgIcon icon="tick" /> Your job has been submitted to the Twine
            team for review before going live
          </h3>
          <div className="f f-row f-xs-col jc-center">
            <div className={`${hasInvited ? 'f-07' : ''} m`}>
              <BriefDetail
                isReview
                narrow={!hasInvited}
                brief={brief}
                browseURL={`${brief.links.ats_main_relative}`}
                owner={owner}
                editable={get(auth, ['user', 'id'], null) === owner.id} // TODO: Also check that a pitch has not been accepted
                isOwner={get(auth, ['user', 'id'], null) === owner.id}
                onSaveEdit={(edits, tempAvatar = null, key = '') =>
                  this.handleUpdateBrief(brief, edits, tempAvatar, key)
                }
                user={auth.user}
              />
            </div>
            {hasInvited && (
              <div className="f-03 f-col m">
                <UserSnippets
                  linksActive={false}
                  freelancers={invitedFreelancers}
                />
              </div>
            )}
          </div>
        </div>
      );
    }

    if (params.subsection === 'brief' && brief) {
      return (
        <div className={`container ${styles.container}`}>
          {header}
          <Breadcrumbs className={styles.breadcrumbs}>
            <Link to="/ats">Manage Jobs</Link>
            <Link
              to={brief.links.ats_main_relative || brief.links.main_relative}
            >
              Job Status
            </Link>
            Job Details
          </Breadcrumbs>
          <BriefDetail
            brief={brief}
            owner={owner}
            editable={get(auth, ['user', 'id'], null) === owner.id} // TODO: Also check that a pitch has not been accepted
            isOwner={get(auth, ['user', 'id'], null) === owner.id}
            onSaveEdit={(edits, tempAvatar = null, key = '') =>
              this.handleUpdateBrief(brief, edits, tempAvatar, key)
            }
            user={auth.user}
          />
        </div>
      );
    }

    if (params.subsection === 'questions' && brief) {
      return (
        <div className={`container ${styles.container}`}>
          {header}
          <Breadcrumbs className={styles.breadcrumbs}>
            <Link to="/ats">Manage Jobs</Link>
            <Link
              to={brief.links.ats_main_relative || brief.links.main_relative}
            >
              Job Status
            </Link>
            Public Questions
          </Breadcrumbs>
          <PublicQuestionsList
            more={get(briefs, [encodedId, 'morePublicQuestions'], false)}
            postingAnswers={Object.keys(publicQuestions).filter((questionId) =>
              get(publicQuestions, [questionId, 'answering'], false)
            )}
            loading={get(briefs, [encodedId, 'loadingPublicQuestions'], false)}
            onAnswer={(question, answer) =>
              this.handleAnswerQuestion(brief, question, answer)
            }
            onLoadMore={() =>
              this.props.loadPublicQuestions(
                encodedId,
                get(briefs, [encodedId, 'publicQuestionsPagesLoaded'], 0) + 1
              )
            }
            questions={get(briefs, [encodedId, 'publicQuestions'], []).map(
              (question) => get(entities, ['publicQuestions', question], false)
            )}
          />
        </div>
      );
    }

    if (params.subsection === 'invites' && brief) {
      return (
        <div className={`container ${styles.container}`}>
          {header}
          <Breadcrumbs className={styles.breadcrumbs}>
            <Link to="/ats">Manage Jobs</Link>
            <Link
              to={brief.links.ats_main_relative || brief.links.main_relative}
            >
              Job Status
            </Link>
            Invites
          </Breadcrumbs>
          Here be invites
        </div>
      );
    }

    // Pinder view
    const rightColumn = (
      <div>
        {owner && (
          <PendingPitchCounter
            brief={brief}
            encodedId={encodedId}
            hideForMobile
          />
        )}

        {owner && (
          <BuyerOnboarding
            loading={!get(auth, ['loaded'], false)}
            noOfInvites={invitedFreelancers.length}
            browseURL={this.handleBrowseFreelancers()}
            onUpdateUser={(fields, temp = null, key = '') =>
              this.handleUpdateUser(fields, temp, key)
            }
            updating={get(auth, ['updatingKeys'], [])}
            user={owner}
          />
        )}
        {owner && (
          <Expandable boxshadow title="Manage project" startExpanded>
            <ul className={styles.actionList}>
              <li>
                <>
                  💬{' '}
                  <Link
                    to={`${brief.links.main_relative}/questions`}
                    title="View questions"
                  >
                    View public questions
                  </Link>
                </>
                <Label
                  color="danger"
                  className={`${styles.label} ${
                    totalPendingPublicQuestions > 0 ? styles.show : ''
                  }`}
                >
                  {totalPendingPublicQuestions}
                </Label>
              </li>
              <li>
                <>
                  ✏️{' '}
                  <Link
                    to={`${brief.links.main_relative}/brief`}
                    title="View brief"
                  >
                    View or edit project
                  </Link>
                </>
              </li>
              <li>
                {brief.ai_recruiter ? (
                  <>
                    🤖{' '}
                    <a onClick={this.handleDisableAIRecruiter}>
                      Disable AI recruiter
                    </a>
                  </>
                ) : (
                  <>
                    ✨{' '}
                    <a onClick={this.handleEnableAIRecruiter}>
                      Enable AI recruiter
                    </a>
                  </>
                )}
              </li>
              <li>
                <>
                  ✈️{' '}
                  <a
                    href="https://www.twine.net/enterprise"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Boost your job for 7 days
                  </a>
                </>
              </li>
              <li>
                <>
                  🚀{' '}
                  <a
                    href="https://www.twine.net/enterprise"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Boost your job for 30 days
                  </a>
                </>
              </li>
              <li>
                {/* Quick actions - close or open job for another 30 days */}
                {brief.active ? (
                  <>
                    🔒{' '}
                    <a onClick={this.handleCloseJobForNewPitches}>
                      Close to new applicants
                    </a>
                  </>
                ) : (
                  <>
                    🔓{' '}
                    <a onClick={this.handleOpenJobForNewPitches}>
                      Open to new applicants
                    </a>
                  </>
                )}
              </li>
            </ul>
          </Expandable>
        )}
        {hasInvited && (
          <UserSnippets
            linksActive
            expandable
            freelancers={invitedFreelancers}
          />
        )}
      </div>
    );

    if (auth.user && owner && auth.user.id === owner.id) {
      const pitchListProps = {
        brief,
        more: get(briefs, [encodedId, 'morePendingPitches'], false),
        onAccepted: (pitch, totalToPay) =>
          this.handleAcceptPitch(pitch, totalToPay),

        onDeclined: (pitch) => this.props.declinePitch(encodedId, brief, pitch),

        onSendMessage: this.props.sendMessage,
        markAsRead: this.props.markAsRead,
      };

      return (
        <div className={`container ${styles.container}`}>
          {header}
          <div className={styles.leftColumn}>
            <div className={styles.pendingPitches}>
              <PitchBox
                brief={this.getBrief()}
                onAccepted={(pitch, totalToPay) =>
                  this.handleAcceptPitch(pitch, totalToPay)
                }
                onDeclined={(pitch) =>
                  this.props.declinePitch(encodedId, brief, pitch)
                }
                params={params}
                encodedId={encodedId}
                pitchListProps={pitchListProps}
              />
            </div>
          </div>
          <div className={styles.rightColumnMobile}>{rightColumn}</div>
          <div className={styles.rightColumn}>{rightColumn}</div>
          <Modal show={showCompanyCheck} title="What best describes you?">
            <div className={styles.companyCheck}>
              <Button
                bsStyle="primary"
                onClick={() => this.handleUpdateOrganisation(true)}
              >
                <SvgIcon icon="office" />
                <br />
                Company
              </Button>
              <Button
                bsStyle="info"
                onClick={() => this.handleUpdateOrganisation(false)}
              >
                <SvgIcon icon="user" />
                <br />
                Individual
              </Button>
            </div>
          </Modal>
          <Modal
            closeButton
            onExit={() => this.setState({ showAddVoucher: false })}
            show={showAddVoucher}
            title="Add voucher"
          >
            <input
              className="form-control"
              onChange={(event) =>
                this.setState({ voucherCode: event.target.value })
              }
              type="text"
              value={voucherCode}
            />
            <Button
              bsStyle="success"
              className={styles.addVoucherButton}
              disabled={
                get(briefs, [encodedId, 'addingVoucher'], false) ||
                voucherCode === ''
              }
              onClick={() => {
                this.props.addVoucher(encodedId, brief, voucherCode);
                this.setState({ showAddVoucher: false });
              }}
            >
              Add voucher
            </Button>
          </Modal>
        </div>
      );
    }

    return <BriefDetailsFreelancer {...this.props} encodedId={encodedId} />;
  }
}

export default BriefDetailsClient;
